import { RevealWrapper } from '@/hooks/useRevealAnimation'
import { values } from '@/mocks/home'

export default function ValuesSection() {
  return (
    <section id="values" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        {/* Header */}
        <RevealWrapper>
          <div className="reveal text-center mb-14 md:mb-20">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 inline-block" />
              Core Values
            </div>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-primary-700 mb-4">
              다온이 추구하는 <span className="text-accent-500">핵심 가치</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              모든 활동의 중심에는 사람과 마음에 대한 깊은 존중이 있습니다.
            </p>
          </div>
        </RevealWrapper>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {values.map((value, idx) => (
            <RevealWrapper key={value.id}>
              <div
                className={`reveal reveal-delay-${idx + 1} group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 hover:-translate-y-1`}
              >
                {/* Image */}
                <div className="relative h-44 md:h-52 overflow-hidden">
                  <img
                    src={value.image}
                    alt={value.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent" />
                </div>

                {/* Content */}
                <div className="p-5 md:p-6 text-center">
                  <p className="text-xs text-accent-500 font-medium mb-1 tracking-wide uppercase">
                    {value.subtitle}
                  </p>
                  <h3 className="text-xl md:text-2xl font-semibold text-primary-700 mb-3">
                    {value.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed whitespace-pre-line">
                    {value.description}
                  </p>
                </div>
              </div>
            </RevealWrapper>
          ))}
        </div>
      </div>
    </section>
  )
}